import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import styles from "./DemoPage.module.css";

export default function DemoPage({
  title,
  highlight,
  subtitle,
  label,
  exchanges,
}) {
  return (
    <div className={styles.page}>
      <div className={styles.background}>
        <div className={styles.glow} />
      </div>
      <div className={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/" className={styles.backLink}>
            &larr; Back to Home
          </Link>

          <div className={styles.header}>
            <span className={styles.label}>{label || "Research Session"}</span>
            <h1 className={styles.title}>
              {title} <span className={styles.titleHighlight}>{highlight}</span>
            </h1>
            <p className={styles.subtitle}>{subtitle}</p>
          </div>

          <div className={styles.chat}>
            {exchanges.map((exchange, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={styles.exchange}
              >
                <div className={styles.roundLabel}>Round {i + 1}</div>

                {/* Researcher message */}
                <div className={styles.messageRow}>
                  <div className={styles.avatar}>R</div>
                  <div className={styles.bubbleResearcher}>
                    <div className={styles.senderLabel}>Researcher</div>
                    <p>{exchange.prompt}</p>
                  </div>
                </div>

                {/* MitoAgent response */}
                <div className={`${styles.messageRow} ${styles.agentRow}`}>
                  <div className={`${styles.avatar} ${styles.avatarAgent}`}>
                    M
                  </div>
                  <div className={styles.bubbleAgent}>
                    <div className={styles.senderLabel}>
                      MitoAgent
                      {exchange.time && (
                        <span className={styles.timeTag}>
                          ⏱ {exchange.time}
                        </span>
                      )}
                    </div>
                    <div className={styles.responseBody}>
                      {exchange.response.map((para, j) => (
                        <p key={j} className={styles.responsePara}>
                          {para}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className={styles.cta}>
            <p className={styles.ctaText}>
              Want MitoAgent reasoning over your data?
            </p>
            <Link to="/playground" className={styles.ctaButton}>
              Apply for Beta Access &rarr;
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
